module.exports = __webpack_public_path__ + "055d7d6972a413b69a205030cee0cc34.png";